import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core/'
import { makeStyles } from '@material-ui/core/styles'
import {
  registerAction,
  authHandlingErrors,
} from '../../../../redux/actions/auth'
import style from './Common.module.css'
import { withRouter, Link } from 'react-router-dom'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: '26px',
  },
}))

const SignContent = ({
  onClose,
  backToLogin,
  registerAction,
  authHandlingErrors,
  errors,
  history,
}) => {
  const classes = useStyles()

  const [userObj, setUserObj] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    terms_of_service: false,
  })

  const [file, setFile] = useState(null)
  const [fileName, setFileName] = useState(null)
  const [validate, setValidate] = useState(false)

  useEffect(() => {
    const listener = (event) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        signUpHandler()
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    }
    document.addEventListener('keydown', listener)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      document.removeEventListener('keydown', listener)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userObj, errors, file, fileName])

  useEffect(() => {
    if (Object.keys(errors)?.length > 0) {
      authHandlingErrors({})
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleUploadImage = (e) => {
    e.preventDefault()
    const errorsCopy = JSON.parse(JSON.stringify(errors))
    if (errorsCopy && errorsCopy.file) {
      delete errorsCopy.file
      authHandlingErrors(errorsCopy)
    }
    let file = e.target.files[0]
    setFile(file)

    if (file && file.name) {
      setFileName(file.name)
    }
  }

  const handleChange = (event) => {
    const { value, name } = event.target
    const errorsCopy = JSON.parse(JSON.stringify(errors))
    if (errorsCopy && errorsCopy[name]) {
      delete errorsCopy[name]
      authHandlingErrors(errorsCopy)
    }
    const copyUserObj = { ...userObj }

    copyUserObj[name] = value

    setUserObj(copyUserObj)
  }

  const handleCheck = (e) => {
    setUserObj({ ...userObj, terms_of_service: e.target.checked })
    setValidate(false)
    const errorsCopy = JSON.parse(JSON.stringify(errors))
    if (errorsCopy && errorsCopy.terms_of_service && e.target.checked) {
      delete errorsCopy.terms_of_service
      authHandlingErrors(errorsCopy)
    }
  }

  const redirectHandler = () => {
    history.push({
      pathname: '/',
      state: { loginIsopen: true },
    })
  }

  const signUpHandler = () => {
    setValidate(true)
    const formData = new FormData()
    formData.append('email', userObj.email)
    formData.append('name', userObj.name)
    formData.append('password', userObj.password)
    formData.append('password_confirmation', userObj.password_confirmation)
    formData.append('terms_of_service', userObj.terms_of_service)
    if (file) {
      formData.append('file', file)
    }

    registerAction(formData, onClose, redirectHandler)
  }

  return (
    <>
      <div className={style.wrapper}>
        <TextField
          error={errors && errors.name ? true : false}
          className={classes.root}
          label="User Name"
          variant="outlined"
          name="name"
          onChange={handleChange}
          helperText={errors && errors.name ? errors.name : ''}
        />
        <TextField
          error={errors && errors.email ? true : false}
          className={classes.root}
          label="Email Address"
          variant="outlined"
          name="email"
          onChange={handleChange}
          helperText={errors && errors.email ? errors.email : ''}
        />
        <TextField
          error={errors && errors.password ? true : false}
          className={classes.root}
          label="Password"
          variant="outlined"
          type="password"
          name="password"
          onChange={handleChange}
          helperText={errors && errors.password ? errors.password : ''}
        />
        <TextField
          className={classes.root}
          label="Repeat Password"
          variant="outlined"
          type="password"
          name="password_confirmation"
          onChange={handleChange}
        />
        <FormControlLabel
          className={style.tw}
          control={
            <Checkbox
              checked={userObj.terms_of_service}
              onChange={handleCheck}
            />
          }
          label={
            <div className={style.pr}>
              <span>{`By registering you agree to our `}</span>
              <Link target="_blank" to="/termsofservice.html">
                Terms of Service
              </Link>
              <span>
                {` and receiving occasional notification emails, you can opt-out
                anytime.`}
              </span>
              {validate && errors?.terms_of_service && (
                <span className={style.te}>{errors.terms_of_service}</span>
              )}
            </div>
          }
        />
        <div className={style.linkBlock}>
          {fileName && <div className={style.uploadFileName}>{fileName}</div>}
          <label htmlFor="logo" className={style.linkText}>
            upload profile photo
          </label>
          <input
            id="logo"
            className={style.uploadInput}
            type="file"
            onChange={handleUploadImage}
          />
          <div className={style.Errors}>
            {' '}
            {errors && errors.file ? errors.file : ''}
          </div>
        </div>
      </div>
      <div className={style.btnGroup}>
        <Button onClick={backToLogin}>back to login</Button>
        <Button onClick={signUpHandler}>Register</Button>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    errors: state.auth.errors,
  }
}
const mapDispatchToProps = {
  registerAction,
  authHandlingErrors,
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignContent),
)
